export const padNumber = (num: number, len = 9) => num.toString().padStart(len, "0");

export const getSpacedFromCamel = (str: string) => str.replace(/([A-Z])/g, " $1");
export const getSpacedFromCamel_Cap = (str: string) =>
    getSpacedFromCamel(str.charAt(0).toUpperCase() + str.slice(1));
export const getSpacedFromCamel_Low = (str: string) =>
    getSpacedFromCamel(str).toLowerCase();
export const getSpacedFromCamel_Low_FirstCap = (str: string) =>
    // getSpacedFromCamel(str).toLowerCase()[0]
    str.charAt(0).toUpperCase() + getSpacedFromCamel(str.slice(1)).toLowerCase();
export const getCamelFromSpaced = (str: string) =>
    str.replace(/\s(\w)/g, (_, letter) => letter.toUpperCase());
export const getCamelFromSpaced_Low = (str: string) =>
    getCamelFromSpaced(str.toLowerCase());

export const getFirstCap = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);
export const getFirstLow = (str: string) => str.charAt(0).toLowerCase() + str.slice(1);

export const replaceBraces = (str: string, replace: string) =>
    str?.replace(/{([^}]+)}/g, (match, key) => replace);

export const replaceBracesByObj = (str: string, obj: { [key: string]: any }) =>
    str?.replace(/{([^}]+)}/g, (match, key: string) => key in obj ? obj[key] : match);

export const numberToLetter = (num: number) => {
    num = Math.max(0, Math.min(25, num));
    return String.fromCharCode(num + 65);
}

export const isInteger = (str: string) => /^\d+$/.test(str);

export const getNullableString = (str: string | null | undefined, defaultStr = "-") => str || defaultStr;
